<script>
/**
 * ****************************************************************************
 * @description     :   Switch Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of switch component
 */
var FcSwitch = {
    template: template,
    props: {
        id: String,
        label: String,
        checkboxLabel: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        isShowCheckbox: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Boolean,
            default: false
        },
        isDisabled: Boolean,
        onChange: Function
    },
    emits: ['update:modelValue'],
    computed: {
        value() {
            return this.modelValue;
        }
    },
    methods: {
        /**
         * click change value input checkbox
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(e) {
            const value = !this.value;
            this.$emit('update:modelValue', value);
            if (this.onChange) {
                this.onChange(e, value);
            }
        }
    }
};
export default FcSwitch;
</script>
